import React from 'react'
import PropTypes from 'prop-types'
import { getNotificationContent } from '../content'
import { relativeTimeParts } from '../relativeTime'

const PublishDelayDetail = ({ notification, onPublish, publishDisabled, t }) => {
  const { title, body } = getNotificationContent(notification, t)
  const time = relativeTimeParts(notification.createdAt)

  return (
    <React.Fragment>
      <div className="NotificationDetail-Category NotificationDetail-Category--warning">
        {t('notificationCenter.types.publishDelay.category')}
      </div>
      <div className="NotificationDetail-Summary">
        <p className="NotificationDetail-Summary-Title">{title}</p>
        <p className="NotificationDetail-Summary-Time">{t(time.key, time.options)}</p>
      </div>
      {body && <p className="NotificationDetail-Description">{body}</p>}
      <button
        type="button"
        className="NotificationDetail-ReviewButton"
        onClick={onPublish}
        disabled={publishDisabled}
      >
        {t('notificationCenter.types.publishDelay.publishAction')}
      </button>
    </React.Fragment>
  )
}

PublishDelayDetail.propTypes = {
  notification: PropTypes.object.isRequired,
  onPublish: PropTypes.func.isRequired,
  publishDisabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

export default PublishDelayDetail
